import { FuelButton, FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useHostGlobals from 'appHost/Globals';
import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useGetTruckerQueriesData } from 'hooks/useGetTruckerQueriesData';
import { useRiskManagement } from 'hooks/useRiskManagement';
import { useSendTracking } from 'hooks/useSendTracking';
import { useTruckerProps } from 'hooks/useTruckerProps';
import React from 'react';
import { useTms } from 'hooks/useTms';
import { useTruckerNavigation } from 'hooks/useNavigation';
import * as Styled from './styled';

export const CreateRiskSearch: React.FC<{
  buttonSize?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary';
  isPaidFee?: boolean;
}> = ({ buttonSize, variant, isPaidFee }) => {
  const { truckerData } = useGetTruckerQueriesData();

  const global = useHostGlobals();
  const { navigateToRiskManagement, riskManagamentButtonIsVisible } = useRiskManagement();
  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();
  const { hasTmsCteAcces } = useTms();
  const { freight, truckerId, eventsSource, freightId, onClose } = useTruckerProps();
  const { handleNavigation } = useTruckerNavigation();

  if (!riskManagamentButtonIsVisible) return null;

  const handleNavigate = () => {
    sendAmplitude('trucker_profile_safety_check', {
      source: eventsSource,
      truckerId,
      isVerified: truckerData?.isVerified,
      freightCode: freight ? freight?.code : textConstants.notAvailaible,
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_safety_check',
        data: {
          source: eventsSource,
          isVerified: truckerData?.isVerified,
          truckerId: `hashed|${truckerId}`,
          freightId: freightId ? `hashed|${freightId}` : textConstants.notAvailaible,
        },
      },
      'trucker_profile'
    );

    global?.dispatchToGlobal?.({ type: 'set_trucker_profile', payload: {} });
    onClose?.();
    navigateToRiskManagement(truckerId, freightId);
  };

  const handleEventSimpleCTE = () => {
    sendAmplitude('tms.fb.profile_trucker_cte_button_clicked', {
      source: 'emitir-cte',
    });
    handleNavigation('/tms?emissao-simples');
  };

  return (
    <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km1', alignItems: 'center' }}>
      <FuelFlex defaultProps={{ gap: 'km3' }}>
        <FuelButton data-testid="risk-management-button" variant={variant} onClick={handleNavigate} size={buttonSize}>
          Gerenciamento de risco
        </FuelButton>
        {hasTmsCteAcces && (
          <FuelButton data-testid="tms-button" variant={variant} size={buttonSize} onClick={handleEventSimpleCTE}>
            Emitir CT-e
          </FuelButton>
        )}
      </FuelFlex>

      {isPaidFee && (
        <FuelFlex defaultProps={{ gap: 'km1', alignItems: 'center' }} testId="paid-fee-content-wrapper">
          <Styled.ValueText>
            <FuelTypography color="neutral-weak" weight="bold" size="caption">
              R$ {process.env.SECURITY_FEE_VALUE}
            </FuelTypography>
          </Styled.ValueText>
          <FuelTag
            label="GRÁTIS"
            color="green"
            shape="rectangle"
            highlight
            uppercase
            data-testid="tag-free-consultation"
          />
        </FuelFlex>
      )}
    </FuelFlex>
  );
};

CreateRiskSearch.defaultProps = {
  buttonSize: 'medium',
  variant: 'primary',
  isPaidFee: false,
};
